import React from "react";
import { useHistory } from "react-router-dom";

export default function PeopleCard({ person, textEllipse }) {
  const history = useHistory();

  const userDetails = () => {
    history.push(`people/${person.id}`);
  };

  return (
    <div
      className="rounded card_shadow cursor-pointer md:border"
      onClick={() => userDetails()}
    >
      <img
        className={`object-fill w-full h-32 md:h-72`}
        src={person.profileImage}
        alt="community image"
        loading="lazy"
      />
      <div className="p-1 md:p-4">
        <div className="text- font-bold">{person.fullName}</div>
        <div className="text-xs">{person.matricNumber}</div>
        <div className="text-xs">{person.graduationYear}</div>
      </div>
    </div>
  );
}
